import React from 'react';
import { Linkedin } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-logo">AutoMeta LLC</h3>
            <p className="footer-tagline">Expert AI solutions for businesses of all sizes.</p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4 className="footer-title">Support</h4>
              <a href="mailto:info@autometallc.com" className="footer-link">Email Support</a>
              <a href="tel:+13059686399" className="footer-link">Phone Support</a>
            </div>
            <div className="footer-column">
              <h4 className="footer-title">Services</h4>
              <a href="#" className="footer-link">AI Consultation</a>
              <a href="#" className="footer-link">Custom Solutions</a>
            </div>
          </div>

          <div className="footer-contact">
            <h4 className="footer-title">Contact</h4>
            <a href="mailto:info@autometallc.com" className="footer-link">info@autometallc.com</a>
            <a href="tel:+13059686399" className="footer-link">+1 305 968 6399</a>
            <a
              href="https://www.linkedin.com/company/autometa-llc"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social"
              aria-label="LinkedIn"
            >
              <Linkedin size={20} />
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2025 AutoMeta LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;